import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { ProspectListTab } from "@/app/types/prospect/ProspectListTab";

const PROSPECT_TAB_LABEL_KEYS: Record<ProspectListTab, TKey> = {
  [ProspectListTab.ALL]: TKey.PROSPECT_SEARCH_FILTER_ALL,
  [ProspectListTab.NEW]: TKey.PROSPECT_SEARCH_FILTER_NEW,
  [ProspectListTab.QUALIFIED]: TKey.PROSPECT_SEARCH_FILTER_QUALIFIED,
  [ProspectListTab.REJECTED]: TKey.PROSPECT_SEARCH_FILTER_REJECTED,
};

export function prospectTabOptions(t: TFn): [string, string][] {
  return Object.values(ProspectListTab).map((tab) => [
    tab,
    String(t(PROSPECT_TAB_LABEL_KEYS[tab])),
  ]);
}

export type ProspectListPlaceholderRow = {
  name: string;
  role: string;
  signals: string[];
  score: string;
};

export const PROSPECT_LIST_PLACEHOLDER_ROWS: ProspectListPlaceholderRow[] = [
  { name: "74%", role: "54%", signals: ["76%", "52%"], score: "44px" },
  { name: "66%", role: "48%", signals: ["66%", "80%"], score: "44px" },
  { name: "80%", role: "58%", signals: ["56%", "70%"], score: "44px" },
  { name: "70%", role: "50%", signals: ["78%", "48%"], score: "44px" },
  { name: "62%", role: "44%", signals: ["70%", "62%"], score: "44px" },
];
